module.exports = __webpack_public_path__ + "img/Phone.8082427f.png";